import { CSSProperties, FC } from "react";
import Popover from "antd/es/popover";
import Space from "antd/es/space";
import Text from "common/Typography/Text";
import { useTheme } from "styled-components";
import { typography } from "@shared/common/Themes/typography";
import IconWithFallback from "Global/IconWithFallback.tsx";
import { ICON_TYPES } from "@shared/common/constants.ts";
import Flex from "common/Boxes/Flex.tsx";
import { useBottomNavigator } from "utils/hooks/misc.tsx";

interface PreviousValuePopoverProps {
  popupsContainerId: string;
  valueChanged?: boolean;
  value: React.JSX.Element | string | number;
  previousValue: React.JSX.Element | string | number;
  alignBottom?: boolean;
  color?: string;
  mediumWeight?: boolean;
  valueName: string;
  coin?: string;
}

const PreviousValuePopover: FC<PreviousValuePopoverProps> = ({
  popupsContainerId,
  value,
  previousValue,
  valueChanged,
  alignBottom,
  color,
  mediumWeight,
  valueName,
  coin,
}) => {
  const appTheme = useTheme();
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();

  const getPreviousValueTooltipContent = () => (
    <Space size={4} orientation="vertical">
      <Text as={"div"} $size={typography.fontSizes.S} type={"secondary"}>
        Original {valueName}
      </Text>
      <Text as={"div"} $size={typography.fontSizes.S}>
        {previousValue}
      </Text>
    </Space>
  );

  const textStyles: CSSProperties = {
    fontSize: "inherit",
    width: "fit-content",
  };

  return (
    <Popover
      content={getPreviousValueTooltipContent()}
      trigger={valueChanged && !isBottomNavigator ? ["hover"] : []}
      getPopupContainer={() => document.getElementById(popupsContainerId)!}
      placement={alignBottom ? "bottomLeft" : undefined}
    >
      <Flex $justifyContent="flex-start">
        {coin && (
          <IconWithFallback
            iconType={ICON_TYPES.COIN}
            coinOrExchangeName={coin}
            iconStyle={{ marginRight: 6 }}
          />
        )}
        <Text
          as="div"
          $weight={
            // New look: values are 500 (never heavier than the labels' titles).
            mediumWeight || appTheme.isNewLook
              ? typography.fontWeights.MEDIUM
              : typography.fontWeights.SEMI_BOLD
          }
          color={
            valueChanged
              ? appTheme.colors.primaryBlue
              : color || appTheme.colors.primaryText
          }
          style={textStyles}
          onClick={(e: React.MouseEvent) => {
            if (valueChanged && !isBottomNavigator) e.stopPropagation();
          }}
        >
          {value}
        </Text>
      </Flex>
    </Popover>
  );
};

export default PreviousValuePopover;
